import React, { useEffect } from "react";
import SvgIcn from "../../data/IconCompo";
import Inputz from "../../ui/atoms/Inputz";
import DropDownz from "../../ui/atoms/DropDownz";

const DashboardControls = ({
  activeView,
  multipleImagesRef,
  jsonFileRef,
  setShowAddItemModal,
  handleSearch,
  handleDropdownSelect,
  searchTerm,
  roleFilter,
  categoryFilter,
  filteredDataLength,
  handleAddManyItems,
  handleUploadImages,
  counts,
}) => {
  return (
    <div className="dashboard-controls">
      <div className="btns-box">
        <input
          type="file"
          multiple
          accept="image/*"
          ref={multipleImagesRef}
          style={{ display: "none" }}
          onChange={(e) => handleUploadImages(e)}
        />
        <button
          className="message-all"
          onClick={() => multipleImagesRef.current?.click()}
        >
          <SvgIcn name="images" />
        </button>

        <button
          className="message-all"
          onClick={() => setShowAddItemModal(true)}
        >
          <SvgIcn name="add" />
        </button>

        <input
          type="file"
          accept=".json"
          ref={jsonFileRef}
          style={{ display: "none" }}
          onChange={(e) => handleAddManyItems(e)}
        />
        <button
          className="message-all"
          onClick={() => jsonFileRef.current?.click()}
        >
          <SvgIcn name="add_project" />
        </button>
      </div>

      {activeView === "users" ? (
        <UserRoleDropdown
          roleFilter={roleFilter}
          handleDropdownSelect={handleDropdownSelect}
        />
      ) : (
        <CategoryDropdown
          categoryFilter={categoryFilter}
          handleDropdownSelect={handleDropdownSelect}
          counts={counts}
        />
      )}

      <Inputz
        iconL="search"
        label="Search"
        name="search"
        placeholder="Search"
        className="search-box"
        iconClear={"clear"}
        hovericonClear={"clear"}
        value={searchTerm}
        onChange={handleSearch}
        counter={filteredDataLength}
      />
    </div>
  );
};

const UserRoleDropdown = ({ roleFilter, handleDropdownSelect }) => (
  <DropDownz
    iconL="hum2"
    focusL="line"
    iconR="drop_down"
    iconRHover="drop_up"
    iconClear="clear"
    focusR="cal"
    className="drop-down"
    placeholder="Select Role"
    onSelect={handleDropdownSelect}
    value={roleFilter}
  >
    <span>All</span>
    <span>UX Designer</span>
    <span>UI Designer</span>
    <span>Product Designer</span>
    <span>Motion Designer</span>
    <span>Graphic Designer</span>
    <span>Others - Designer</span>
    <span>Frontend Developer</span>
    <span>Backend Developer</span>
    <span>Full Stack Developer</span>
    <span>Manager</span>
    <span>Marketer</span>
    <span>Director</span>
    <span>Student</span>
  </DropDownz>
);

const CategoryDropdown = ({ categoryFilter, handleDropdownSelect, counts }) => {
  const categories = [
    { name: "TOOLS", key: "tools" },
    { name: "RESOS", key: "resos" },
    { name: "IDEAZ", key: "ideaz" },
    { name: "APPS", key: "apps" },
  ];

  return (
    <DropDownz
      iconL="hum2"
      focusL="line"
      iconR="drop_down"
      iconRHover="drop_up"
      iconClear="clear"
      focusR="cal"
      className="drop-down"
      placeholder="Select Category"
      onSelect={handleDropdownSelect}
      value={categoryFilter}
      name="category"
    >
      <span>ALL</span>
      {categories.map((cat) => (
        <span key={cat.key}>
          {cat.name} <div>{counts[cat.key]}</div>
        </span>
      ))}
    </DropDownz>
  );
};

export default DashboardControls;
